import React from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

import styles from './Instalments.module.scss';

const Instalments = ({ 
    lyriaUrl,
    instalmentPlanId,
    intalmentPlanStatus,
    currency,
    instalments,
    nextInstalmentToPay,
    processingInstalmentRequestUuid,
    processingInstalmentRequestIndex,
    redirectToInstalmentRequest,
    setError,
}) => {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = React.useState(false);

    const instalmentToShowPayNowButton = React.useMemo(() => {
        const finishedInstalmentPlanStatus = ['validated', 'V', 'terminated', 'T', 'aborted', 'A'];
        // only consider displaying button for non-finished instalment plan
        if (!finishedInstalmentPlanStatus.includes(intalmentPlanStatus)) {
            // Priority 1: instalment with is_due_now === true
            const dueNowInstalment = instalments.find(i => i.status === null && i.is_due_now);
            if (dueNowInstalment) return dueNowInstalment;
    
            // Priority 2: aborted instalment with index match with processing instalment request (if available)
            if (processingInstalmentRequestUuid && processingInstalmentRequestIndex != null) {
                return instalments.find(i => i.instalment_index === processingInstalmentRequestIndex && i.status === 'A');
            }

            // Priority 3: last aborted instalment (A) with no validated after (if no processing instalment request available)
            const lastAbortedInstalment = [...instalments].reverse().find(i => i.status === 'A');
            if (lastAbortedInstalment) {
                const lastAbortedIndex = instalments.lastIndexOf(lastAbortedInstalment);
                const hasValidatedAfter = instalments.slice(lastAbortedIndex + 1).some(i => i.status === 'V');
                if (!hasValidatedAfter) return lastAbortedInstalment;
            }
        }

        return null;
    }, [instalments, intalmentPlanStatus, processingInstalmentRequestIndex, processingInstalmentRequestUuid]);

    const handlePayNowButtonClick = React.useCallback(async () => {
        // redirect to processing instalment request if there is one
        if (processingInstalmentRequestUuid && processingInstalmentRequestIndex) {
            redirectToInstalmentRequest(processingInstalmentRequestUuid);
        } else {
            // otherwise -> create new one and redirect to it
            setIsLoading(true);
            axios({
                method: 'post',
                url: `${lyriaUrl}/instalment_plan/plan/${instalmentPlanId}/instalmentrequest/`,
            }).then(({ data }) => {
                redirectToInstalmentRequest(data.id);
            }).catch(( error ) => {
                setError(error.message);
                console.error(error);
            });
            setIsLoading(false);
        }
    }, [instalmentPlanId, lyriaUrl, processingInstalmentRequestIndex, processingInstalmentRequestUuid, redirectToInstalmentRequest, setError]);

    return (
        <div className={styles.instalments_content}>
            <h2>{t('paymentSchedule')}</h2>
            {isLoading && <Loader />}
            {instalments?.map((instalment, index) => (
                <div key={index} className={`${styles.instalment} ${instalment.status == 'V' && styles.background_validated}`}>
                    <div
                        className={`
                            ${styles.left_instalment}
                            ${instalment.status == 'V' && styles.green_border}
                            ${instalment.status == 'A' && styles.red_border}
                            ${instalment.status != 'A' && instalment.status != 'V' && (instalment.is_due_now ? styles.yellow_border : styles.grey_border)}
                        `}
                    >
                        <p className={styles.label}>
                            {instalment.instalment_index == 1 && t('firstInstalment')}
                            {instalment.instalment_index == 2 && t('secondInstalment')}
                            {instalment.instalment_index == 3 && t('thirdInstalment')}
                            {instalment.instalment_index >= 4 && t('fourthAndMoreInstalment', { index: instalment.instalment_index })}
                        </p>
                        <p className={styles.due_date}>
                            {instalment.status == 'V' ? instalment.attempted_at.replaceAll('-', '/').split('T')[0] : instalment.due_date.replaceAll('-', '/').split('T')[0]}
                        </p>
                        <p className={`
                            ${styles.status}
                            ${instalment.status == 'V' && `${styles.status_validated}`}
                            ${instalment.status == 'A' && `${styles.status_aborted}`}
                            ${instalment.status != 'A' && instalment.status != 'V' && (instalment.is_due_now ? `${styles.status_due}` : `${styles.status_to_validate}`)}
                        `}>
                            {instalment.status == 'V' && t('paid')}
                            {instalment.status == 'A' && t('missed')}
                            {instalment.status !== 'V' && instalment.status !== 'A' && (instalment.is_due_now ? t('due') : t('scheduled'))}
                        </p>
                    </div>
                    <div className={styles.right_instalment}>
                        <p className={styles.amount}>
                            {t('price.' + currency, {
                                count: instalment?.amount,
                            })}
                        </p>
                        {/* {(instalment.status === 'V' || instalment.status === 'A') &&
                            <button disabled={instalment.status == 'V' || instalment.status == 'A'} className={instalment.status == 'A' && `${styles.red_text}`}>
                                {instalment.status == 'V' && t('paid')}
                                {instalment.status == 'A' && t('missed')}
                                {instalment.status != 'V' && instalment.status != 'A' && t('payNow')}
                            </button>
                        } */}
                        {instalment === instalmentToShowPayNowButton &&
                            <button onClick={handlePayNowButtonClick}>{t('payNow')}</button>
                        }
                        {nextInstalmentToPay == instalment &&
                            <button style={{ display: 'none' }} onClick={handlePayNowButtonClick}>{t('payNow')}</button>
                        }
                        {/* {nextInstalmentToPay !== instalment && instalment.status != 'V' &&
                            <button style={{ visibility: 'hidden' }}></button>
                        } */}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default Instalments;
